import { createContext, useContext, useState } from "react";

const DICT = {
  id: {
    nav_explore: "Jelajahi Aksi",
    nav_match: "Kenali Dirimu",
    nav_planner: "Social Action Planner",
    nav_organizer: "Organizer Hub",
    nav_profile: "Profil & Dampak Saya",
    search_placeholder: "Cari aksi...",
    create_initiative: "Buat Inisiatif",
    city_label: "Kota:",
    all_cities: "Semua Kota",
    hero_badge: "Platform Kolaborasi Aksi Sosial & Dampak Berkelanjutan — Pilot Phase 2026",
    hero_title_1: "Dari Niat Baik,",
    hero_title_2: "Jadi Aksi Nyata.",
    hero_sub: "Temukan aksi sosial paling cocok dengan keahlianmu, dapatkan playbook solusi untuk masalah di lingkunganmu, dan bergabung dengan ribuan relawan terverifikasi di seluruh Indonesia.",
    hero_cta_match: "Mulai Kenali Dirimu",
    hero_cta_explore: "Jelajahi Aksi",
    stat_volunteers: "Relawan Aktif",
    stat_hours: "Jam Kontribusi",
    stat_projects: "Proyek Selesai",
    feature_match_desc: "Jawab 4 pertanyaan, dapatkan profil aksi personal & rekomendasi kegiatan paling cocok.",
    feature_planner_desc: "Rencanakan aksi warga, komunitas, hingga program CSR — AI menyusun playbook 8 bagian lengkap.",
    feature_explore_desc: "Filter berdasarkan isu, format, dan kota. Lihat peta sebaran aksi di seluruh Indonesia.",
    open: "Buka",
    nearby_title: "Aksi Terdekat Membutuhkanmu",
    nearby_sub: "Inisiatif komunitas dengan slot relawan yang masih terbuka.",
    see_all: "Lihat Semua",
    tour_label: "Quick Demo Tour",
    tour_match: "1. Coba Kenali Dirimu",
    tour_planner: "2. Coba Social Action Planner",
    tour_dashboard: "3. Dasbor Dampak B2B",
    explore_title: "Jelajahi Aksi & Komunitas",
    explore_sub: "Temukan inisiatif warga terverifikasi di sekitarmu.",
    planner_title_1: "Punya Masalah di Lingkunganmu?",
    planner_title_2: "AI Susun Rencana Aksinya.",
    planner_sub: "Mesin perencana aksi adaptif multi-sektor: dari aksi warga hingga program CSR — playbook operasional 8 bagian, dokumen resmi, dan jembatan menjadi proyek komunitas.",
    planner_problem_label: "Ceritakan masalah lingkungan atau sosial yang dihadapi dan rencanakan aksi sosial/CSR sekarang.",
    planner_generate: "Buat Rencana Aksi",
    planner_generating: "AI Menyusun Playbook...",
    templates_title: "Community Action Library — Template Cepat",
    organizer_title: "Organizer Hub",
    organizer_sub: "Kelola inisiatif, relawan, laporan warga, dan dampak organisasimu.",
    export_report: "Ekspor Laporan Dampak",
    demo_badge: "Demo Mode — Sample Data",
    sample_badge: "Sample Data / Demo Mode",
    profile_badges: "Lencana Dampak",
    profile_history: "Riwayat Aksi",
    convert_ready: "Rencana Aksimu Siap — Jadikan Proyek Komunitas",
    convert_btn: "Convert to Community Project",
    convert_desc: "Publikasikan rencana ini sebagai proyek di Organizer Hub & Jelajahi Aksi — lengkap dengan peran relawan dan target indikator.",
    convert_success: "Proyek komunitas berhasil dipublikasikan ke Jelajahi Aksi & Organizer Hub!",
    convert_error: "Gagal mengonversi rencana menjadi proyek.",
    pb_s1: "Analisis Masalah & Tujuan",
    pb_s2: "Timeline Implementasi",
    pb_s3: "Matriks Peran & Tugas Relawan",
    pb_s4: "3 Skenario Anggaran & Logistik",
    pb_s5: "Keselamatan, Risiko & Mitigasi",
    pb_s6: "Rekomendasi Mitra & Stakeholder",
    pb_s7: "Keselarasan SDG & Indikator Dampak",
    pb_s8: "Generator Dokumen Administratif & Legal",
    pb_root: "Akar Masalah",
    pb_benef: "Penerima Manfaat",
    pb_goals: "Tujuan Terukur",
    pb_reco: "REKOMENDASI",
    mx_title: "Aktivitas → Output → Outcome (Status Bukti)",
    mx_all_cat: "Semua Kategori",
    mx_all_status: "Semua Status",
    mx_activity: "Aktivitas",
    mx_output: "Output Langsung",
    mx_outcome: "Outcome Terverifikasi",
    mx_status: "Status",
    mx_evidence: "Bukti",
    mx_evidence_status: "Status Bukti",
    mx_empty: "Tidak ada data sesuai filter.",
    rp_page: "Halaman",
    rp_subtitle: "CSR & Community Readiness · Semester I — 2026 · 3 Halaman",
    rp_title1: "Ringkasan Eksekutif, Indikator Kunci & Dokumentasi",
    rp_title2: "Kontribusi SDG, Matriks Output vs Outcome & Analitik Relawan",
    rp_title3: "Evaluasi, Tantangan Lapangan, Pembelajaran & Langkah Lanjut",
    rp_stat_vol: "Relawan Dimobilisasi",
    rp_stat_act: "Aktivitas Selesai",
    rp_stat_att: "Kehadiran Terverifikasi (PIN/QR)",
    rp_stat_hours: "Jam Relawan",
    rp_stat_cities: "Kota Terjangkau",
    rp_econ: "Valuasi Ekonomi Transparan",
    rp_formula_mid: "Total Jam Relawan ×",
    rp_formula_end: "/jam (estimasi nilai standar)",
    rp_source: "Sumber data: sistem check-in PIN/QR, laporan organizer, dan dokumentasi lapangan. Status bukti ditandai per proyek di halaman 2.",
    rp_sdg_head: "Kontribusi SDG & Justifikasi Metodologi",
    rp_matrix_head: "Matriks Aktivitas → Output → Outcome Terverifikasi",
    rp_va_head: "Analitik Relawan",
    rp_va_return: "Relawan Kembali / Baru",
    rp_va_att: "Tingkat Kehadiran",
    rp_challenges: "Tantangan Lapangan",
    rp_lessons: "Pembelajaran",
    rp_next: "Langkah Lanjut",
    rp_resolution: "Rasio penyelesaian isu lingkungan",
    rp_footer: "Disusun otomatis oleh BergerakNyata — data sampel demo, siap audit untuk pelaporan CSR & ESG mitra.",
    rp_close: "Tutup",
    rp_print: "Unduh / Cetak Laporan PDF",
    rp_public_title: "Laporan Dampak Publik",
    rp_public_sub: "Versi publik yang dapat dibagikan — Demo Mode, Sample Data.",
    rp_public_print: "Cetak",
    ikuti_aksi: "Ikuti Aksi",
    kuota_penuh: "Kuota Penuh",
  },
  en: {
    nav_explore: "Explore Actions",
    nav_match: "Discover Your Role",
    nav_planner: "Social Action Planner",
    nav_organizer: "Organizer Hub",
    nav_profile: "My Profile & Impact",
    search_placeholder: "Search actions...",
    create_initiative: "Create Initiative",
    city_label: "City:",
    all_cities: "All Cities",
    hero_badge: "Social Action Collaboration & Sustainable Impact Platform — Pilot Phase 2026",
    hero_title_1: "From Good Intentions,",
    hero_title_2: "To Real Action.",
    hero_sub: "Find the social actions that best match your skills, get AI solution playbooks for problems around you, and join thousands of verified volunteers across Indonesia.",
    hero_cta_match: "Start Discover Your Role",
    hero_cta_explore: "Explore Actions",
    stat_volunteers: "Active Volunteers",
    stat_hours: "Contribution Hours",
    stat_projects: "Projects Completed",
    feature_match_desc: "Answer 4 questions and get a personal action profile with best-matched activities.",
    feature_planner_desc: "Plan citizen, community, or CSR programs — AI builds a complete 8-part playbook.",
    feature_explore_desc: "Filter by issue, format, and city. View the action map across Indonesia.",
    open: "Open",
    nearby_title: "Nearby Actions Need You",
    nearby_sub: "Community initiatives with open volunteer slots.",
    see_all: "See All",
    tour_label: "Quick Demo Tour",
    tour_match: "1. Try Discover Your Role",
    tour_planner: "2. Try Social Action Planner",
    tour_dashboard: "3. B2B Impact Dashboard",
    explore_title: "Explore Actions & Communities",
    explore_sub: "Find verified citizen initiatives around you.",
    planner_title_1: "Facing a Problem in Your Area?",
    planner_title_2: "Let AI Draft the Action Plan.",
    planner_sub: "Adaptive multi-sector action planner: from citizen actions to CSR programs — an 8-part operational playbook, formal documents, and a bridge into a community project.",
    planner_problem_label: "Describe the environmental or social problem you face and plan your social/CSR action now.",
    planner_generate: "Generate Action Plan",
    planner_generating: "AI is Building the Playbook...",
    templates_title: "Community Action Library — Quick Templates",
    organizer_title: "Organizer Hub",
    organizer_sub: "Manage initiatives, volunteers, citizen reports, and your organization's impact.",
    export_report: "Export Impact Report",
    demo_badge: "Demo Mode — Sample Data",
    sample_badge: "Sample Data / Demo Mode",
    profile_badges: "Impact Badges",
    profile_history: "Action History",
    convert_ready: "Your Action Plan Is Ready — Convert to Community Project",
    convert_btn: "Convert to Community Project",
    convert_desc: "Publish this plan as a project in the Organizer Hub & Explore Actions — complete with volunteer roles and target indicators.",
    convert_success: "Community project published to Explore Actions & Organizer Hub!",
    convert_error: "Failed to convert the plan into a project.",
    pb_s1: "Problem Analysis & Goals",
    pb_s2: "Implementation Timeline",
    pb_s3: "Volunteer Roles & Task Matrix",
    pb_s4: "3 Budget & Logistics Scenarios",
    pb_s5: "Safety, Risks & Mitigation",
    pb_s6: "Partner & Stakeholder Recommendations",
    pb_s7: "SDG Alignment & Impact Indicators",
    pb_s8: "Administrative & Legal Document Generator",
    pb_root: "Root Cause",
    pb_benef: "Beneficiaries",
    pb_goals: "Measurable Goals",
    pb_reco: "RECOMMENDED",
    mx_title: "Activity → Output → Outcome (Evidence Status)",
    mx_all_cat: "All Categories",
    mx_all_status: "All Statuses",
    mx_activity: "Activity",
    mx_output: "Direct Output",
    mx_outcome: "Verified Outcome",
    mx_status: "Status",
    mx_evidence: "Evidence",
    mx_evidence_status: "Evidence Status",
    mx_empty: "No data matches the filters.",
    rp_page: "Page",
    rp_subtitle: "CSR & Community Readiness · Semester I — 2026 · 3 Pages",
    rp_title1: "Executive Summary, Key Indicators & Documentation",
    rp_title2: "SDG Contribution, Output vs Outcome Matrix & Volunteer Analytics",
    rp_title3: "Evaluation, Field Challenges, Lessons & Next Steps",
    rp_stat_vol: "Volunteers Mobilized",
    rp_stat_act: "Activities Completed",
    rp_stat_att: "Verified Attendance (PIN/QR)",
    rp_stat_hours: "Volunteer Hours",
    rp_stat_cities: "Cities Reached",
    rp_econ: "Transparent Economic Valuation",
    rp_formula_mid: "Total Volunteer Hours ×",
    rp_formula_end: "/hour (standard value estimate)",
    rp_source: "Data sources: PIN/QR check-in system, organizer reports, and field documentation. Evidence status is flagged per project on page 2.",
    rp_sdg_head: "SDG Contribution & Methodology Justification",
    rp_matrix_head: "Verified Activity → Output → Outcome Matrix",
    rp_va_head: "Volunteer Analytics",
    rp_va_return: "Returning / New Volunteers",
    rp_va_att: "Attendance Rate",
    rp_challenges: "Field Challenges",
    rp_lessons: "Lessons Learned",
    rp_next: "Next Steps",
    rp_resolution: "Environmental issue resolution ratio",
    rp_footer: "Automatically compiled by BergerakNyata — demo sample data, audit-ready for partner CSR & ESG reporting.",
    rp_close: "Close",
    rp_print: "Download / Print PDF Report",
    rp_public_title: "Public Impact Report",
    rp_public_sub: "Shareable public version — Demo Mode, Sample Data.",
    rp_public_print: "Print",
    ikuti_aksi: "Join Action",
    kuota_penuh: "Slots Full",
  },
};

const STORAGE_KEY = "bn.lang";
const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem(STORAGE_KEY) || "id");
  const setLang = (l) => { setLangState(l); localStorage.setItem(STORAGE_KEY, l); };
  const t = (key) => DICT[lang]?.[key] ?? DICT.id[key] ?? key;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
